var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "toggle-container" }, [
    _c(
      "div",
      { staticClass: "trigger", on: { click: _vm.toggle } },
      [
        _vm._t("trigger", function () {
          return [
            _c("p", { staticClass: "flex items-center" }, [
              _c("span", [_vm._v("深度思考")]),
              _vm._v("  "),
              _c("i", {
                staticClass: "pointer",
                class: _vm.isVisible
                  ? "el-icon-arrow-down"
                  : "el-icon-arrow-up",
              }),
            ]),
          ]
        }),
      ],
      2
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isVisible,
            expression: "isVisible",
          },
        ],
        staticClass: "content",
      },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }